import React, { useEffect } from "react";


import Col1 from "../components/cols/Col1";
import Col3 from "../components/cols/Col3";
import Col4 from "../components/cols/Col4";
import Section1 from "../components/Sections/Section1";
import Body from "../components/Wrapper/Body";
import { Helmet } from "react-helmet";
import PartnersSection from "../components/Sections/PartnersSection";
import EventHero from "../components/Sections/EventHero";
import ChatSection from "../components/Sections/ChatSection";
import BillSection from "../components/Sections/BillSection";
import GiftCardSection from "../components/Sections/GiftCardSection";
import Dispatch from "../components/Sections/Dispatch";

const Home = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  return (
    <Body>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Sprinterwave: Rides, Gift Cards, Dispatch Delivery & Event Tickets
        </title>
        <meta
          name="description"
          content="Sprinterwave is the all-in-one African app for rides, bill payments, buying and selling gift cards, dispatch rider delivery, and event ticket booking. Manage your finances and daily errands effortlessly, all in one place."
        />
        <meta
          name="keywords"
          content="Sprinterwave, ride booking, transport app, transaction processing, bill payment, sell gift cards, buy gift cards, gift card exchange, gift card trading, dispatch rider, dispatch delivery, package delivery, courier service, logistics solutions, event tickets, event ticket booking, event planning, financial management, mobile payments, mobile app, payment app, bill management, logistics app, financial transactions, ticket reservations, digital payments, mobile commerce, utility payments, African fintech app"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.sprinterwave.com/" />

        {/* Open Graph / Facebook, LinkedIn, WhatsApp previews */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Sprinterwave" />
        <meta property="og:locale" content="en_NG" />
        <meta property="og:url" content="https://www.sprinterwave.com/" />
        <meta
          property="og:title"
          content="Sprinterwave: Rides, Gift Cards, Dispatch Delivery & Event Tickets"
        />
        <meta
          property="og:description"
          content="Book rides, pay bills, trade gift cards, send packages with dispatch riders, and buy event tickets, all from one simple app."
        />
        <meta
          property="og:image"
          content="https://www.sprinterwave.com/sprinter.png"
        />
        <meta property="og:image:alt" content="Sprinterwave app" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.sprinterwave.com/" />
        <meta
          name="twitter:title"
          content="Sprinterwave: Rides, Gift Cards, Dispatch Delivery & Event Tickets"
        />
        <meta
          name="twitter:description"
          content="Book rides, pay bills, trade gift cards, send packages with dispatch riders, and buy event tickets, all from one simple app."
        />
        <meta
          name="twitter:image"
          content="https://www.sprinterwave.com/sprinter.png"
        />

        {/* Structured data: Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Sprinterwave",
            url: "https://www.sprinterwave.com/",
            logo: "https://www.sprinterwave.com/sprinter.png",
            description:
              "Sprinterwave is an all-in-one app for ride booking, bill payments, gift card trading, dispatch rider delivery, and event ticket booking.",
          })}
        </script>

        {/* Structured data: Services offered */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            provider: {
              "@type": "Organization",
              name: "Sprinterwave",
            },
            areaServed: "NG",
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "Sprinterwave Services",
              itemListElement: [
                {
                  "@type": "Offer",
                  itemOffered: { "@type": "Service", name: "Ride booking" },
                },
                {
                  "@type": "Offer",
                  itemOffered: { "@type": "Service", name: "Bill payments" },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Gift card buying and selling",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Dispatch rider delivery",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Event ticket booking",
                  },
                },
              ],
            },
          })}
        </script>
      </Helmet>

      <Section1 />
      <Col1 />
      <GiftCardSection />

      <Dispatch />

      {/* <RideSection /> */}
      <BillSection />
      <EventHero />
      <ChatSection />

      <PartnersSection />

      {/* Cols */}

      {/* <StatsCounter /> */}
      <br></br>

      <br></br>
      <br></br>
      <br></br>
      <Col3 />
      <br></br>
      <br></br>
      <br></br>
      <Col4 />
      <br></br>
    </Body>
  );
};

export default Home;
